/* eslint-disable @typescript-eslint/no-explicit-any */
import { BehaviorSubject, Observable, UnaryFunction, combineLatest, distinctUntilChanged, map, pipe } from 'rxjs';

export class RxJSUtils {
  public static observableToBehaviorSubject<T>(observable: Observable<T>, initValue: T): BehaviorSubject<T> {
    const subject = new BehaviorSubject(initValue);
    observable.subscribe(subject);
    return subject;
  }

  public static someLoading(...observables: Observable<boolean>[]): Observable<boolean> {
    return combineLatest(observables).pipe(
      map((array) => array.some(Boolean)),
      distinctUntilChanged(),
    );
  }

  public static operatorFunctionsToOperatorFunction(operators: UnaryFunction<any, any>[]): UnaryFunction<any, any> {
    if (operators.length <= 0) {
      return pipe();
    } else if (operators.length === 1) {
      return operators[0];
    } else if (operators.length === 2) {
      return pipe(operators[0], operators[1]);
    } else if (operators.length === 3) {
      return pipe(operators[0], operators[1], operators[2]);
    } else if (operators.length === 4) {
      return pipe(operators[0], operators[1], operators[2], operators[3]);
    } else if (operators.length === 5) {
      return pipe(operators[0], operators[1], operators[2], operators[3], operators[4]);
    } else if (operators.length === 6) {
      return pipe(operators[0], operators[1], operators[2], operators[3], operators[4], operators[5]);
    } else if (operators.length === 7) {
      return pipe(operators[0], operators[1], operators[2], operators[3], operators[4], operators[5], operators[6]);
    } else if (operators.length === 8) {
      return pipe(
        operators[0],
        operators[1],
        operators[2],
        operators[3],
        operators[4],
        operators[5],
        operators[6],
        operators[7],
      );
    } else if (operators.length === 9) {
      return pipe(
        operators[0],
        operators[1],
        operators[2],
        operators[3],
        operators[4],
        operators[5],
        operators[6],
        operators[7],
        operators[8],
      );
    } else if (operators.length >= 10) {
      const spreadOperators = operators.slice(9);
      return pipe(
        operators[0],
        operators[1],
        operators[2],
        operators[3],
        operators[4],
        operators[5],
        operators[6],
        operators[7],
        operators[8],
        ...spreadOperators,
      );
    } else {
      return pipe();
    }
  }
}
